import { Table } from "semantic-ui-react";

interface IProps {
    tableData: string[][];
}

export const TableComponent = ({ tableData }: IProps) => {
    return (
        <>
            {tableData.length !== 0 && (
                <Table celled>
                    <Table.Header>
                        <Table.Row>
                            {tableData[0].map((cell, index) => (
                                <Table.HeaderCell key={index}>{cell}</Table.HeaderCell>
                            ))}
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {tableData
                            .filter((_, index) => index !== 0)
                            .map((row, index) => (
                                <Table.Row key={index}>
                                    {row.map((cell, index) => (
                                        <Table.Cell key={index}>{cell}</Table.Cell>
                                    ))}
                                </Table.Row>
                            ))}
                    </Table.Body>
                </Table>
            )}
        </>
    );
};
